<div id="appdesktop" *ngIf="acheckin && acheckin.length>0">

    <div class="whiteBg_container mb-3">
        <h3 class="fontSize19 pb-2">Today's Inperson Appointments</h3>
        <div class="table-responsive drTable">
            <table class="table align-middle">
                <thead>
                    <tr>
                        <th>
                            <p>Date & Time</p>
                        </th>
                        <th>
                            <p>Patient Name</p>
                        </th>
                        <th>
                            <p>Physician Name</p>
                        </th>
                        <th>
                            <p class="centerlaign">Action</p>
                        </th>
                    </tr>
                </thead>
                <tbody class="table">
                    <tr *ngFor="let item of acheckin; let i = index">
                        <td>
                            <p>{{ item["apdate"] | date: "dd/MM/yyyy" }} | {{item.aptime }}</p>
                        </td>
                        <td>
                            <p> {{ (item["patient_first_name"] === null &&
                                item["patient_last_name"] === null)?
                                "Not Available":item["patient_first_name"]+"
                                "+item["patient_last_name"]}}</p>
                        </td>
                        <td>
                            <p> Dr.&nbsp;{{ item["physician_first_name"] }}
                                {{ item["physician_last_name"] }}</p>
                        </td>
                        <td *ngIf="item.chkstatus== 'Pending'">

                            <!-- <button type="button" class="btn btn-sm btn-info" style="float: none; margin: 5px;"
                                [routerLink]="['/appointments/Checkin/edit/' + item.aid]">
                                <span class="ti-pencil"></span>
                            </button> -->

                            <a href="#" [routerLink]="['/appointments/Checkin/edit/' + item.aid]"
                                style="float: left; margin: 2px;border:none;"><img src="/assets/images/editIcon.svg"
                                    alt="icon">
                            </a>

                            <!-- <button type="button" class=" btn-primary" style="float: none; margin: 5px;" [routerLink]="[
        '/appointments/Checkin/Detail/' + item.aid]"> Check In </button> -->

                            <a style="float:left; margin: 2px; border: none; "
                                [routerLink]="['/appointments/Checkin/Detail/' + item.aid]">
                                <img src="/assets/images/checkout.svg" alt="icon"> CheckIn
                            </a>

                        </td>
                        <td *ngIf="item.chkstatus != 'Pending'">
                            <p class="centerlaign">{{ item.chkstatus }}</p>
                        </td>

                    </tr>

                </tbody>
            </table>
        </div>
    </div>

    <!-- <div class="card m-b-30">
        <div class="card-body table-responsive">
            <div class="row">
                <div align="center" class="col-lg-12">

                    <h5 class="pt-3 header-title heading-color">
                        TODAY'S INPERSON APPOINTMENTS
                    </h5>


                </div>
            </div>

            <div *ngIf="acheckin.length>0" id="datatable2_wrapper"
                class="dataTables_wrapper container-fluid dt-bootstrap4 no-footer">
                <div class="row">
                    <div class="col-md-12 mt-5 detail-tbl">
                        <table class="table">
                            <thead>
                                <tr>
                                    <th scope="col">
                                        AP DATE & TIME
                                    </th>

                                    <th scope="col">
                                        PATIENT
                                    </th>
                                    <th scope="col">
                                        PHYSICIAN
                                    </th>

                                    <th scope="col">
                                        ACTION
                                    </th>
                                </tr>
                            </thead>



                            <tr *ngFor="let item of acheckin; let i = index">
                                <td class="font-size-15 ">{{ item["apdate"] | date: "dd/MM/yyyy" }}
                                    <br />{{item.aptime }}
                                
                                </td>


                                <td class="font-size-15 ">
                                    {{ (item["patient_first_name"] === null &&
                                    item["patient_last_name"] === null)?
                                    "Not Available":item["patient_first_name"]+"
                                    "+item["patient_last_name"]}}
                                </td>

                                <td class="font-size-15 ">
                                    Dr.&nbsp;{{ item["physician_first_name"] }}
                                    {{ item["physician_last_name"] }}
                                </td>


                                <td *ngIf="item.chkstatus == 'Pending'">

                                    <div class="tabledit-toolbar btn-toolbar" style="text-align: center;">
                                        <div class="btn-group btn-group-sm" style="float: none;">
                                            <button type="button" class="tabledit-edit-button btn btn-sm btn-info"
                                                style="float: none; margin: 5px;" [routerLink]="[
                                        '/appointments/Checkin/edit/' + item.aid
                                      ]">
                                                <span class="ti-pencil"></span>
                                            </button>
                                            <button type="button" class="tabledit-delete-button btn btn-sm btn-primary"
                                                style="float: none; margin: 5px;" [routerLink]="[
                                        '/appointments/Checkin/Detail/' + item.aid
                                      ]">
                                              
                                                Check In
                                            </button>
                                        </div>
                                    </div>
                                </td>



                                <td *ngIf="item.chkstatus != 'Pending'" class="font-size-15">
                                    {{ item.chkstatus }}
                                </td>


                            </tr>


                        </table>


                    </div>

                </div>

            </div>
            <br /><br />
            <div [innerHTML]="innerHtml"></div>

        </div>

    </div> -->

    <!-- /appdesktop -->

    <div id="appmobile">
        <div class="col-sm-12">
            <h5 class="header-title heading-color center-mobile">SCHEDULED APPOINTMENTS</h5>
        </div>
        <div [innerHTML]="innerHtml"></div>
        <div class="row" *ngFor="let item of acheckin; let i = index">

            <div class="col-12 col-sm-12">

                <div class="mcard">

                    <div class="cardrow">
                        <div class="cardcol">
                            <span class="textgrey">AP DATE</span>
                        </div>
                        <div class="cardcol">
                            <span class="textblack">{{ item["apdate"] | date: "dd-MM-yyyy" }}
                            </span>
                        </div>
                    </div>
                    <!-- /cardrow -->
                    <div class="cardrow">
                        <div class="cardcol">
                            <span class="textgrey">AP TIME</span>
                        </div>
                        <div class="cardcol">
                            <span class="textblack">{{ formatTime(item["aptime"]) }}

                            </span>
                        </div>
                    </div>
                    <!-- /cardrow -->


                    <div class="cardrow">
                        <div class="cardcol">
                            <span class="textgrey">PATIENT</span>
                        </div>
                        <div class="cardcol">
                            <!--<span class="textblack">{{ item["patient_first_name"] }}
                    &nbsp;{{ item["patient_last_name"] }}
                  </span>-->
                            <span class="textblack">
                                {{ (item["patient_first_name"] === null && item["patient_last_name"] === null)? "Not
                                Available":item["patient_first_name"]+" "+item["patient_last_name"]}}
                            </span>
                        </div>
                    </div>
                    <!-- /cardrow -->
                    <div class="cardrow">
                        <div class="cardcol">
                            <span class="textgrey">DOB</span>
                        </div>
                        <div class="cardcol">
                            <!--<span class="textblack">{{
                    item["dob"] | date: "dd-MMM-yyyy"
                    }}</span>-->
                            <span class="textblack">{{ item["dob"] === null? "Not Available":(item["dob"] | date:
                                "dd-MMM-yyyy")}}</span>
                        </div>
                    </div>
                    <!-- /cardrow -->
                    <div class="cardrow">
                        <div class="cardcol">
                            <span class="textgrey">CONSULTING DOCTOR</span>
                        </div>
                        <div class="cardcol">
                            <span class="textblack text-capitalize">{{ item["physician_title"] ?
                                item["physician_title"] :
                                defaultDr}}
                                &nbsp; {{ item["physician_first_name"] }}
                                &nbsp; {{ item["physician_last_name"] }}
                            </span>
                        </div>
                    </div>
                    <!-- /cardrow -->
                    <div class="cardrow" *ngIf="item.chkstatus == 'Pending'">
                        <div class="btn-group btn-group-sm actionbtm">
                            <button type="button" class="tabledit-edit-button btn btn-sm btn-info"
                                style="float: none; margin: 5px;"
                                [routerLink]="['/appointments/Checkin/edit/' + item.aid]">
                                <span class="ti-pencil"></span>
                            </button>
                            <button type="button" class="tabledit-delete-button btn btn-sm btn-primary"
                                style="float: none; margin: 5px;"
                                [routerLink]="['/appointments/Checkin/Detail/' + item.aid]">
                                <!-- <span class="ti-trash"></span> -->
                                Check In
                            </button>
                        </div>
                    </div><br>
                    <!-- /cardrow -->
                    <div class="center-mobile" *ngIf="item.chkstatus !== 'Pending'">
                        <h5 align="center">
                            <button class="btn-sm btn-success" style="float: none; margin: 5px;">
                                {{ item.chkstatus }}
                            </button>

                        </h5>
                    </div>
                </div>


            </div>
            <!-- /col -->
            <div [innerHTML]="innerHtml">
            </div>
        </div>
        <!-- /row -->
    </div>
    <!-- /appmobile -->

    <!--end container-->
</div>